import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-muted-foreground text-center md:text-left">
            <p>© {currentYear} Schuler Consultants. All rights reserved.</p>
            <p className="mt-1">GameFeed.io - Your Ultimate Gaming News Hub</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link 
              to="/privacy-policy" 
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-muted-foreground">•</span>
            <Link 
              to="/cookie-policy" 
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Cookie Policy
            </Link>
            <span className="text-muted-foreground">•</span>
            <a 
              href="mailto:info@gamefeed.io" 
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
